// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PhoneVerificationStatusAPIModel {
    Verified = 'Verified',
    NotVerified = 'NotVerified'
}

export function PhoneVerificationStatusAPIModelFromJSON(json: any): PhoneVerificationStatusAPIModel {
    return PhoneVerificationStatusAPIModelFromJSONTyped(json, false);
}

export function PhoneVerificationStatusAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneVerificationStatusAPIModel {
    return json as PhoneVerificationStatusAPIModel;
}

export function PhoneVerificationStatusAPIModelToJSON(value?: PhoneVerificationStatusAPIModel | null): any {
    return value as any;
}

